





























import Vue, { PropType } from "vue";
import AuthenticationService from "../services/AuthenticationService";
import AuthenticationServiceFactory from "../services/AuthenticationServiceFactory";
import HttpClient from "../services/HttpClient";
import HttpClientFactory from "../services/HttpClientFactory";
import UserCredentials from "../types/auth/UserCredentials";
export default Vue.extend({
  props: {
    email: {
      type: String,
    },
    userCredentials: {
      type: Object as PropType<UserCredentials | null>,
    },
  },
  data() {
    return {
      httpClient: {} as HttpClient,
      authenticationService: null as AuthenticationService | null,
      emailNotConfirmedAlert: true as boolean,
      resendEmailAlert: false as boolean,
      loadingResendEmail: false as boolean,
      resendEmailAlertError: false as boolean,
      msgAlert: "",
    };
  },
  created() {
    this.httpClient = HttpClientFactory.getInstance();
    this.authenticationService = AuthenticationServiceFactory.getInstance();
  },
  methods: {
    async resendEmailConfirmation() {
      this.emailNotConfirmedAlert = false;
      this.loadingResendEmail = true;
      try {
        if (this.userCredentials && this.userCredentials.username !== "") {
          await this.httpClient.post(
            process.env.VUE_APP_BACKEND_ENDPOINT +
              "/auth/v1/resend-email-confirmation",
            {
              username: this.userCredentials.username,
            }
          );
          this.loadingResendEmail = false;
          this.resendEmailAlert = true;
          this.msgAlert = this.$t("auth:login.email_resend_successfully");
          setTimeout(() => {
            this.resendEmailAlert = false;
          }, 3000);
        }

        this.loadingResendEmail = false;
        this.resendEmailAlertError = true;
        setTimeout(() => {
          this.resendEmailAlertError = false;
        }, 4000);
        this.msgAlert = this.$t("auth:login.error_try_again");
      } catch (e) {
        const error: any = {
          text: this.$t("auth:login.error"),
          type: "error",
        };
        this.$notify(error);
      }
    },
  },
});
